import { useState, type CSSProperties, type FormEvent, type ReactNode } from 'react';
import { Link } from 'wouter';
import { categories, searchContent } from '../data/site';

export function PageHero({ kicker, title, description, action }: { kicker: string; title: string; description: string; action?: ReactNode }) {
  return <section className="page-hero"><div className="container page-hero-inner"><div><div className="page-kicker">{kicker}</div><h1>{title}</h1><p>{description}</p></div>{action}</div></section>;
}

export function CategoryGrid() {
  return <div className="category-grid">{categories.map((item) => <Link href={item.href} className="category-card" key={item.name} style={{ '--tint': item.tint } as CSSProperties}>
    <span className="category-top">{item.tag}</span><h3>{item.name}</h3><p>{item.desc}</p><span className="text-link">{item.action}<span aria-hidden="true">→</span></span>
  </Link>)}</div>;
}

export function SearchBar() {
  const [what, setWhat] = useState('');
  const [where, setWhere] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const query = `${what} ${where}`.trim().toLowerCase();
  const ignoredWords = new Set(['in', 'at', 'the', 'for', 'near', 'of', 'a', 'to']);
  const terms = query.split(/\s+/).filter((word) => word && !ignoredWords.has(word));
  const results = query ? searchContent.filter((item) => terms.every((word) => `${item.title} ${item.terms} ${item.category}`.toLowerCase().includes(word))).slice(0, 5) : [];
  const search = (event: FormEvent) => { event.preventDefault(); setSubmitted(true); };
  return <form className="search-box" onSubmit={search} role="search">
    <div className="search-field"><label htmlFor="sypp-what">What are you looking for?</label><input id="sypp-what" value={what} onChange={(e) => { setWhat(e.target.value); setSubmitted(false); }} placeholder="Hostel, scholarship, internship, university..." autoComplete="off" /></div>
    <div className="search-field"><label htmlFor="sypp-where">Where?</label><input id="sypp-where" value={where} onChange={(e) => { setWhere(e.target.value); setSubmitted(false); }} placeholder="University, city or area" autoComplete="off" /></div>
    <button className="button-primary" type="submit">Search SYPP <span aria-hidden="true">→</span></button>
    {(submitted || query.length > 1) && <div className="search-results" role="status" aria-live="polite">
      {!query ? <p className="form-note">Enter a topic, university or city to search SYPP.</p> : results.length ? results.map((item) => <Link href={item.href} key={`${item.category}-${item.title}`}><span>{item.title}</span><small>{item.category} ↗</small></Link>) : <p className="form-note">No local matches yet. Try “GCUF”, “hostel”, “Canada” or “internship”.</p>}
    </div>}
  </form>;
}

export function SponsorCard({ homepage = false }: { homepage?: boolean }) {
  return <div className="sponsor-card">
    <div className="sponsor-logo-placeholder">Oranexa Ventures Pakistan Logo</div>
    <div><div className="page-kicker">{homepage ? 'Founding Sponsor' : 'Founding Sponsor'}</div><h2>Oranexa Ventures Pakistan</h2><p>{homepage ? "Supporting the development of digital platforms and opportunities for Pakistan's next generation of students." : 'Supporting the early development of SYPP — Student Yellow Pages Pakistan.'}</p></div>
    <span className="pill neutral">Sponsor recognition</span>
  </div>;
}

export function EmptyState({ title, children }: { title: string; children: ReactNode }) {
  return <div className="empty-state"><h3>{title}</h3><p>{children}</p></div>;
}
